const _excluded = ["companyId", "claimGroupId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import ClaimGroupProjectTypesPieChart from '../charts/ClaimGroupProjectTypesPieChart';
import { Col, Row } from 'react-bootstrap';
import CostCollectedProjectsPieChart from '../charts/CostCollectedProjectsPieChart';
import ClaimGroupProjectStatePieChart from '../charts/ClaimGroupProjectStatePieChart';
import projectStatusDashboarService from '../../services/dashboard/project_status_dashboard.service';
export default function ClaimGroupMasterPageDashboard(_ref) {
  let {
      companyId,
      claimGroupId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const dashboardData = projectStatusDashboarService.useFetchDashboardDataForClaimGroup(companyId, claimGroupId);
  dashboardData.projectStatuses = dashboardData !== null && dashboardData !== void 0 && dashboardData.project_statuses ? [dashboardData.project_statuses.not_started, dashboardData.project_statuses.in_progress, dashboardData.project_statuses.completed] : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "mt-3"
  }, "Project Overview"), /*#__PURE__*/React.createElement(Row, props, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(CostCollectedProjectsPieChart, {
    dashboardData: dashboardData,
    titleContainerClassName: "justify-content-center"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ClaimGroupProjectStatePieChart, {
    dashboardData: dashboardData,
    titleContainerClassName: "justify-content-center",
    labels: ['Not Started', 'In Progress', 'Completed']
  })), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ClaimGroupProjectTypesPieChart, {
    dashboardData: dashboardData,
    titleContainerClassName: "justify-content-center"
  }))));
}